import { Named } from './named';
import { IViolation } from './annotation';
import { Metamodel } from '../base/model';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { NamedCompositeValidator } from './named-composite-validator';
import { NamedValidations } from './named-validations';

@Metamodel.model({
    name: 'variables',
    display: [shellStringResources.VariableLabel, shellStringResources.VariablesLabel],
    referable: true,
    globalScope: true,
    constraints: {
        name: {
            required: true,
            validator: NamedCompositeValidator.CreateValidator([
                NamedValidations.KeyWordsValidator,
                NamedValidations.StartsWithNumberValidator])
        },
        defaultValue: {
            validator: Variable.prototype.validateDefaultValue
        },
        _type: {
            validator: Variable.prototype.validateUnsupportedType
        }
    }
})
export class Variable extends Named {
    public defaultValue: string;

    constructor(name?: string, description?: string, id?: number, public _type?: string) {
        super(name, description, id);
    }

    private validateDefaultValue(variable?: Variable, defaultValue?: string): IViolation[] | undefined {
        const violations: IViolation[] = [];

        if (variable && defaultValue) {
            const variableType = variable._type ? variable._type.toLowerCase() : '';

            switch (variableType) {
                case 'integer':
                    if (!Number.isInteger(Number(defaultValue))) {
                        violations.push({
                            message: () => shellStringResources.Invalid_Variable_Integer
                        });
                    }
                    break;
                case 'boolean':
                    if (String(defaultValue) !== 'true' && String(defaultValue) !== 'false') {
                        violations.push({
                            message: () => shellStringResources.Invalid_Variable_Boolean
                        });
                    }
                    break;
                case 'array':
                    try {
                        const defaultArray = JSON.parse(String(defaultValue));

                        if (!Array.isArray(defaultArray)) {
                            violations.push({
                                message: () => shellStringResources.Invalid_Variable_Array
                            });
                        }
                    } catch (error) {
                        violations.push({
                            message: () => shellStringResources.Invalid_Variable_Array
                        });
                    }

                    break;
                default:
                    break;
            }
        }

        return violations.length <= 0 ? undefined : violations;
    }

    private validateUnsupportedType(variable?: Variable, varType?: string): IViolation[] | undefined {
        // Previously Bool used to be a valid type, which has been updated to Boolean. This validation is to get users to change to new Boolean type.

        if (variable && varType) {
            const variableType = varType ? varType.toLowerCase() : '';
            if (!['boolean', 'string', 'array', 'integer'].includes(variableType)) {
                return [({
                    message: () => shellStringResources.Variable_NotValidType
                })];
            }
        }

        return undefined;
    }
}
